import React from 'react'
import cx from 'classnames'

import S from './styled'
import { Portal } from 'react-portal'

const FloatingButton = ({ disabled, onClick, children, additional = [] }) => (
  <Portal>
    <S.FloatingButtonContainer>
      <S.AdditionalContainer className={cx('additional', { visible: additional &&  additional.length })}>
        {
          additional.map(action => {
            return (
              <S.AdditionalButton key={action.name} onClick={action.onClick}>
                {action.icon}
              </S.AdditionalButton>
            )
          })
        }
      </S.AdditionalContainer>
      <S.FloatingButton disabled={disabled} onClick={disabled ? null : onClick}>
        {children}
      </S.FloatingButton>
    </S.FloatingButtonContainer>
  </Portal>
)

export default FloatingButton
